import { Action } from '@ngrx/store';

export const SUBMIT_PASSWORD_FORM = 'SUBMIT_PASSWORD_FORM';

export class SubmitPasswordForm implements Action {
  readonly type = SUBMIT_PASSWORD_FORM;
}

export type PasswordActions = SubmitPasswordForm;
